import { render, staticRenderFns } from "./EtcData.vue?vue&type=template&id=357b94c4&scoped=true"
import script from "./EtcData.vue?vue&type=script&lang=js"
export * from "./EtcData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357b94c4",
  null
  
)

export default component.exports